// src/components/commercial/CommercialFeed.js
import React, { useEffect, useState } from 'react';
import pb from '../../lib/pocketbase';
import { useAuth } from '../../contexts/AuthContext';

export default function CommercialFeed() {
    const { user } = useAuth();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchFeed() {
            try {
                // Fetch recent customers
                const customers = await pb.collection('customers').getList(1, 5, {
                    sort: '-created',
                    filter: `created_by = "${user.id}" || commercial_id = "${user.id}"`
                });

                // Fetch recent won deals
                const wonDeals = await pb.collection('deals').getList(1, 5, {
                    sort: '-updated',
                    filter: `owner = "${user.id}" && status = "won"`
                });

                // Fetch upcoming tasks (simulated from 'tasks' collection if exists, or mocked)
                // Let's assume we fetch tasks
                let tasks = { items: [] };
                try {
                    tasks = await pb.collection('tasks').getList(1, 5, {
                        sort: 'due_date',
                        filter: `read_access ~ "${user.id}" && status != "done"`
                    });
                } catch (e) {
                    // silent fail if tasks collection issue
                }

                const newEvents = [
                    ...customers.items.map(c => ({
                        type: 'lead',
                        date: new Date(c.created),
                        title: 'Nouveau Lead',
                        desc: `${c.name} (${c.company || 'Indépendant'})`,
                        icon: '👤'
                    })),
                    ...wonDeals.items.map(d => ({
                        type: 'deal',
                        date: new Date(d.updated),
                        title: 'Deal Gagné !',
                        desc: `${d.name} - ${d.amount}€`,
                        icon: '🎉'
                    })),
                    ...tasks.items.map(t => ({
                        type: 'task',
                        date: new Date(t.due_date || t.created),
                        title: 'Tâche à faire',
                        desc: t.title,
                        icon: '📌'
                    }))
                ].sort((a, b) => b.date - a.date).slice(0, 10);

                setEvents(newEvents);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        fetchFeed();
    }, [user.id]);

    if (loading) return <div style={{ padding: 20, textAlign: 'center', color: 'var(--admin-muted)' }}>Chargement du fil d'actualité...</div>;

    if (events.length === 0) return (
        <div style={{ padding: 30, textAlign: 'center', color: 'var(--admin-muted)', background: 'var(--admin-panel)', borderRadius: 12, border: '1px solid var(--admin-border)' }}>
            Aucune activité récente.
        </div>
    );

    return (
        <div style={{ background: 'var(--admin-panel)', borderRadius: 12, border: '1px solid var(--admin-border)', padding: '20px', height: '100%', maxHeight: '400px', overflowY: 'auto' }}>
            <h3 style={{ marginTop: 0, marginBottom: 16, fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>🔔</span> Activité Live
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {events.map((ev, i) => (
                    <div key={i} style={{ display: 'flex', gap: 12, padding: '12px 0', borderBottom: i < events.length - 1 ? '1px solid var(--admin-border)' : 'none' }}>
                        <div style={{ fontSize: '1.2rem', background: 'var(--admin-panel-2)', width: 36, height: 36, borderRadius: 18, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                            {ev.icon}
                        </div>
                        <div>
                            <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{ev.title}</div>
                            <div style={{ fontSize: '0.85rem', color: 'var(--admin-text)', marginBottom: 2 }}>{ev.desc}</div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--admin-muted)' }}>{ev.date.toLocaleString()}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
